/**
 * @fileoverview Edge Experiments, Jaanuu's GrowthBook wrapper for feature flagging and experiments. It unlocks the power of
 * Growthbook and front-end experimentation through client-side APIs while sending experimentation data to Heap Analytics
 * for reporting purposes.
 *
 * Version: 1.0.0
 * Author: Cesar Davila
 * Website: https://www.jaanuu.com
 *
 * Include script before closing <code>&lt;/body&gt;</code> tag.
 * <code>
 *   &lt;script src="/cdn/shop/.../edge.js"&gt;&lt;/script&gt;
 * </code>
 */
(function(window, document) {
  /**
   * merge two or more objects vanilla js
   *
   * All credits to author.
   * https://gomakethings.com/vanilla-javascript-version-of-jquery-extend/
   *
   * @param   {Boolean}  deep     If true, do a deep (or recursive) merge [optional]
   * @param   {Object}   objects  The objects to merge together
   * @returns {Object}            Merged values of defaults and options
   */
  function _extend() {
    var extended = {};
    var deep = false;
    var i = 0;
    // Check if a deep merge
    if (typeof (arguments[0]) === "boolean") {
      deep = arguments[0];
      i++;
    }
    // Merge the object into the extended object
    var merge = function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (deep && Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            // If we're doing a deep merge and the property is an object
            extended[prop] = extend(true, extended[prop], obj[prop]);
          } else {
            // Otherwise, do a regular merge
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) { merge(arguments[i]); }
    return extended;
  }

  var isUndefined = function (value) { return value === undefined; };
  var isNull = function (value) { return value === null; };
  var isBoolean = function (value) { return typeof value === "boolean"; };
  var isObject = function (value) { return value === Object(value); };
  var isArray = function (value) { return Array.isArray(value); };
  var isDate = function (value) { return value instanceof Date; };
  var isBlob = function (value) {
    return value &&
      typeof value.size === "number" &&
      typeof value.type === "string" &&
      typeof value.slice === "function";
  }
  const _isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

  /**
  * COOKIE MONSTER -- https://www.quirksmode.org/js/cookies.html
  */
  const Cookies = {
    set: function (cname, cvalue, options) {
      options = options || {};
      var expires = "";
      var cookieDomain = "";
      if ("ttl" in options) {
        var now = new Date();
        now.setTime(now.getTime() + (options.ttl * 1000 * 60));
        expires = ";expires=" + now.toUTCString();
      } else if ("months" in options) {
        var now = new Date();
        now.setMonth(now.getMonth() + options.months)
        expires = ";expires=" + now.toUTCString();
      } else if ("midnight" in options) {
        var now = new Date();
        var date = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        expires = ";expires=" + date.toUTCString();
      }
      if ("domain" in options) {
        cookieDomain = ";domain=" + domain;
      }
      // document.cookie = cname + "=" + cvalue + expires + cookieDomain + ";path=/";
      document.cookie = cname + "=" + escape(cvalue) + expires + cookieDomain + ";path=/";
    },
    get: function (cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          // return c.substring(name.length, c.length);
          return unescape(c.substring(name.length, c.length));
        }
      }
      return null;
    },
    reset: function (cname) { document.cookie = cname + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;"; },
  };

  // program to generate random strings
  const CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  const ALPHANUMERIC_CHARACTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
  function generateString(length = 0, characters) {
    characters = characters || CHARACTERS;
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return result;
  };

  /**
   * Replacement for $(document).ready(function(){ ... });
   * works for all modern browsers, including IE starting from version 9.
   *
   * https://caniuse.com/#feat=domcontentloaded
   * https://stackoverflow.com/questions/9899372/pure-javascript-equivalent-of-jquerys-ready-how-to-call-a-function-when-t
   * @param  {Function} callback  The function to call when dom ready
   * @return {void}
   */
  function documentReady(callback) {
    var readyState = document.readyState;
    if (readyState == "complete" || readyState == "interactive") {
      // do async to allow for other scripts to run
      setTimeout(callback);
    } else {
      document.addEventListener("DOMContentLoaded", callback);
    }
  }

  // Wait for the GrowthBook SDK to load before running
  window.growthbook_queue = window.growthbook_queue || [];
  let growthbook = undefined; // Local reference

  const script = document.currentScript;
  const dataset = script ? script.dataset : {};
  const rootPath = dataset.rootPath;
  const template = !!dataset.template ? JSON.parse(dataset.template) : {};
  const themeRole = dataset.themeRole;
  const themeId = dataset.themeId;
  const envProduction = (dataset.envProduction === "true") || false;

  // maybe need an admin editor UI?
  function createEdgeElement() {
    const d = document.createElement("div");
    d.setAttribute("id", "growthbook-edge-ui");
    document.body.insertBefore(d, document.body.firstChild);
  }

  class Edge {
    constructor(debug, debugTrace) {
      this.createTemplateName = this.createTemplateName.bind(this);
      this.createExperimentId = this.createExperimentId.bind(this);
      this.setDebug = this.setDebug.bind(this);
      this.setDebugTrace = this.setDebugTrace.bind(this);
      this.state = {
        debug: debug || false,
        debugTrace: debugTrace || false,
        disabled: false,
      };
      this.state = _extend(this.state, this.loadState());
      this.log("State Loaded", JSON.stringify(this.state));
    }

    createTemplateName() {
      console.debug("----------------------------------------------------------------------------------------------------------------------------------------")
      console.debug(" You generated a template name to customize how your content is displayed. \n Copy the text to the editor. If the template already exists, run it again until it's unique.");
      console.debug(" ", "gb-" + generateString(10));
      console.debug("----------------------------------------------------------------------------------------------------------------------------------------")
    }

    // Generate a random alphanuimeric string with a custom character set similar to Google Optimize method.
    // https://medium.com/@christ.blais/what-is-so-secure-about-securerandom-776254f1ce1c
    // i.e. zONMidMlRn2NGo-K8Ao_Xg
    createExperimentId() {
      console.debug("----------------------------------------------------------------------------------------------------------------------------------------")
      console.debug(" You generated a Experiment identifier, used for Tracking Key, track impressions and analyze results . \n Copy and pasted in GrowthBook new Experiment. If the indentifer already exists, run it again until it's unique.");
      console.debug(" ", generateString(22, ALPHANUMERIC_CHARACTERS));
      console.debug("----------------------------------------------------------------------------------------------------------------------------------------")
    }

    init() {
      try {
        this.log("Edge script initializing");
        this.log("Theme Settings", { rootPath, template, themeRole, themeId, envProduction });
        if (window.Shopify && window.Shopify.designMode) {
          this.log("Skipping script for design mode");
          this.state.disabled = true;
          return;
        }
        if (window.Shopify && Shopify.jaanuu && Shopify.jaanuu.is_partner_site) {
          this.log("Skipping script for partner site");
          this.state.disabled = true;
          return;
        }
        if (
          window.location.hostname.endsWith(".shopifypreview.com") ||
          window.location.hostname.endsWith(".edgemesh.com")
        ) {
          this.log("Skipping script for preview");
          this.state.disabled = true;
          return;
        }
        if (this.state.disabled) {
          this.state.disabled = false;
        }
        this.run();
      } catch (e) {
        console.error(e);
      }
    }

    /*
    getFeaturesCache() {
      let result = null;
      try {
        if (window.localStorage) {
          const cache = window.localStorage.getItem("gbFeaturesCache") || "[]";
          result = JSON.parse(cache);
          // console.log("features cache", result);
        }
      } catch(e) {
        console.error(e);
      }
      return result;
    }
    */

    // array of experiments:  {ruleId: "", experimentId: "", featureId: "", variationId: ""};
    getCookie() {
      let cookie = (Cookies.get("_jaanuu_essential") && JSON.parse(Cookies.get("_jaanuu_essential"))) || {};
      if ("experiments" in cookie === false) cookie.experiments=[];
      if ("state" in cookie === false) cookie.state={};
      return cookie;
    }

    trackExperiment(experiment, result) {
      if (!experiment || !result)
        return false;
      const saved = this.saveExperiment({
        "featureId": result.featureId,
        "experimentId": experiment.key,
        "variationId": result.variationId
      });
      if (saved) {
        // Experiment started API...
        const hash = { 'Experiment Source': "growthbook" };
        const key = 'Experiment: ' + experiment.key;
        hash[key] = result.variationId;
        window.heap.addEventProperties(hash);
        // window.heap.removeEventProperty('Experiment ' + experiment.key);
        // window.heap.removeEventProperty('Experiment source');
        this.log("Experiment: Heap Hit -> " + experiment.key + "." + result.variationId);
      }
      return saved;
    }

    // track experiment runnig in order to clean up afterwords in Heap
    saveExperiment(experimentResult) {
      const cookie = this.getCookie();
      if (!experimentResult || !cookie?.experiments || !isArray(cookie.experiments))
        return false;
      // get experiment by "ruleId" and "experimentId"
      const index = cookie.experiments.findIndex((exp) => exp.experimentId === experimentResult.experimentId);
      if (index === -1)
        cookie.experiments.push(experimentResult);
      else
        cookie.experiments[index] = _extend(cookie.experiments[index], experimentResult || {});
      Cookies.set("_jaanuu_essential", JSON.stringify(cookie), { months: 12 });
      return true;
    }

    // Track the "ruleId" of the Rule attached to the Feature and Experiment running.
    // - used later when cleaning up Experiments from cookies and Heap.
    updateExperiment(featureKey) {
      if (!featureKey || featureKey === "") return false
      if (!growthbook?.evalFeature(featureKey)) return false;
      const cookie = this.getCookie();
      const evalFeature = growthbook.evalFeature(featureKey);
      const index = cookie.experiments.findIndex((exp) => exp.featureId == featureKey && exp.experimentId == evalFeature.experiment.key);

      if (index === -1) {
        this.log("Skip updating experiment cookie", null);
        return false;
      }

      // TODO double check logic
      if (cookie.experiments[index].ruleId != evalFeature.ruleId) {
        cookie.experiments[index].ruleId = evalFeature.ruleId
        Cookies.set("_jaanuu_essential", JSON.stringify(cookie), { months: 12 });
        this.log("cookied experiment updated", cookie.experiments[index]);
      }
      return true;
    }

    shouldUpdateExperiment(featureKey) {
      const evalFeature = growthbook?.evalFeature(featureKey);
      if (evalFeature?.source == "experiment" &&
        evalFeature?.ruleId !== "" &&
        evalFeature?.experimentResult?.inExperiment
      ) {
        return true;
      }
      return false;
    }


    // Experiment and Heap helper tool
    // - identify experiments no longer running, execute removeEventProperty from Heap and clean up cookie index
    // - only clean up experiments that are no longer running (compares growthbook cache and our custom cookie)
    async cleanupExperimentFinished() {
      // const cache = this.getFeaturesCache();
      if (!growthbook?.getFeatures() || _isEmpty(growthbook.getFeatures()))
        return false
      try {
        const experiments_running = [];
        const experiments_cookie = [];
        // get active experiments/features (GrowthBook SDK)
        // let features = (cache[0] && cache[0].length >= 2 && cache[0][1]?.data?.features) || {};
        const features = growthbook?.getFeatures();
        const keys = Object.keys(features);
        for (let i = 0; i < keys.length; i++) {
          let f = features[keys[i]];
          // this.log(keys[i], f)
          if (f?.rules && isArray(f.rules) && f.rules.length > 0) {
            // const arr = f.rules.filter((rule) => rule?.key && rule?.meta);
            // experiments_running = experiments_running.concat(arr);
            f.rules.filter((rule) => rule?.key && rule?.meta).forEach((rule) => experiments_running.push(rule.id));
          }
        }

        // get cookied experiments
        const cookie = this.getCookie();
        cookie.experiments.filter((exp) => exp?.ruleId).forEach((exp) => experiments_cookie.push(exp.ruleId));

        // Remove Heap event hit and from cookie.
        const runHit = (ruleId) => {
          const index = cookie.experiments.findIndex((exp) => exp?.ruleId && exp.ruleId === ruleId);
          const data = index > -1 ? cookie.experiments[index] : {};
          if (!_isEmpty(data)) {
            // Experiment finishes. Remove the experiment property API.
            window.heap.removeEventProperty("Experiment: " + data.experimentId); // Remove the property
            cookie.experiments.splice(index, 1); // delete it
            Cookies.set("_jaanuu_essential", JSON.stringify(cookie), { months: 12 });
            if (Shopify.debug) { window.console.log("Experiment: " + data.experimentId + " is no longer running"); }
          }
        };
        const runCleanUp = () => {
          this.log("Checking active experiments...")
          this.log("experiments_running", experiments_running)
          this.log("experiments_cookied", experiments_cookie)
          // process cookied experiments
          if ((experiments_running && experiments_running.length > 0) ||
            (experiments_cookie && experiments_cookie.length > 0)) {
            // solve whether an experiment is running with modern approach (Set object)
            const setA = new Set(experiments_running);
            const setB = new Set(experiments_cookie);
            const setDiff = setA.symmetricDifference(setB);
            const arrDiff = Array.from(setDiff);
            this.log("Cleanup experiments", arrDiff);
            arrDiff.forEach((ruleId) => runHit(ruleId));
          }
        };
        runCleanUp();
      } catch(e) {
        console.error(e);
      }
    }

    run() {
      if (!growthbook?.ready) return;
      if (this.state.disabled) return;
      this.cleanupExperimentFinished();
      this.handleVisitor();
    }

    handleVisitor() {
      //TODO: handleRedirectTests() ...
      this.handleTemplateFeatures();
      this.handleFeatures();
      documentReady(() => {
        this.handleDomFeatures();
        this.handleURLFromTest();
      });
    }

    ///// Category of Features

    handleFeatures() {
      // on/off feature
      if (growthbook.isOn("test-my-feature")) {
        this.log("growthbook test-my-feature is enabled!")
      }

      // string variable
      const myFeatureValue = growthbook.getFeatureValue(
        "test-my-feature",
        null
      );
      this.log("growthbook test-my-feature value", myFeatureValue);
    }

    handleDomFeatures() {
      // The header navbar in transparent ui design
      if (document.querySelector('[id^="MainHeader"]')) {
        const featureKey = envProduction ? "header-transparent-navbar:production" : "header-transparent-navbar";
        if (this.shouldUpdateExperiment(featureKey))
          this.updateExperiment(featureKey);
        const isOn = growthbook.getFeatureValue(
          featureKey,
          null
        );
        this.log(`growthbook ${featureKey} value`, isOn);
        if (isOn) {
          const el = document.querySelector('[id^="MainHeader"]');
          el.closest('.section-header').style.height = '0px';
          // el.closest('.section-header').style.overflowY = 'visible';
          el.classList.remove('gradient');
          el.classList.add('gradient-transparent');
          el.setAttribute('data-header-transparent', true);

          if (el.getAttribute('data-header-transparent-color') == "white") {
            el.classList.add('gradient-transparent--white');
            el.querySelector('#header-logo').classList.add('hidden');
            el.querySelector('#header-logo-white')?.classList.remove('hidden');
            el.querySelector('.header__search .search-modal').style.setProperty('--color-foreground', '0, 0, 0');
          }
          //el.querySelector('#geFreeShippingBannerContainer').style.display = 'none';
          // el.querySelector('#header-logo').classList.add('hidden');
          // el.querySelector('#header-logo-white')?.classList.remove('hidden');
          // el.querySelector('.header__search .search-modal').style.setProperty('--color-foreground','0, 0, 0');
          // el.querySelector('#cart-icon-bubble').style.setProperty('--color-button', '255, 255, 255');
          // el.querySelector('#cart-icon-bubble').style.setProperty('--color-button-text', '0, 0, 0');

          // use case: only update when Header (Nav Bar) isn't transparent onload.
          // there maybe some race conditions due to internet latency, runtime stuff etc.
          document.addEventListener('global components loaded', function() {
            try {
              const stickyHeaderNode = document.querySelector("[data-sticky-header]");
              if (window.Shopify && typeof window.Shopify?.getComponent == "function") {
                const stickyHeader = Shopify.getComponent(stickyHeaderNode);
                if (stickyHeader?.headerIsTransparent == false) {
                  console.debug("helooo----")
                  stickyHeader.updateComponent();
                }
              }
            } catch (e) {
              console.error(e);
            }
          });
        }
      }

      // Change Hero Banner button colors
      if (document.querySelector('[id^="HeroBanner-"]')) {
        const featureKey = "hero-banner-button-color";
        if (this.shouldUpdateExperiment(featureKey))
          this.updateExperiment(featureKey);
        const hash = growthbook.getFeatureValue(
          featureKey,
          null
        );
        this.log(`growthbook ${featureKey} value`, hash);
        if (hash?.backgroundColor && hash?.color) {
          const el = document.querySelector('[id^="HeroBanner-"]');
          el.querySelectorAll(".banner__button").forEach((element) => {
            element.style.backgroundColor = hash.backgroundColor;
            element.style.color = hash.color;
          });
        }
      }

      // Image multirow section
      const featureKey = envProduction ? "image-multirow-button-color:production" : "image-multirow-button-color";
      if (this.shouldUpdateExperiment(featureKey))
        this.updateExperiment(featureKey);
      const hash = growthbook.getFeatureValue(
        featureKey,
        null
      );
      this.log(`growthbook ${featureKey} value`, hash);
      if (hash?.backgroundColor && hash?.color) {
        const el = document.querySelector('[id^="image-multirow-"]');
        el.querySelectorAll(".image-with-text .button").forEach((element) => {
          // element.style.setProperty('--color-button-text', '204, 78, 78');
          // element.style.setProperty('--color-button', '223, 222, 222');
          element.style.setProperty('--color-button-text', hash.color);
          element.style.setProperty('--color-button', hash.backgroundColor);
        });
      }
    }

    // List all template feature here
    handleTemplateFeatures() {
      // template feature? If so, then redirect with "view="
      const featureKey = envProduction ? "product-template:production" : "product-template";
      const templateValue = this.testForTemplate(featureKey);
      if (this.shouldUpdateExperiment(featureKey))
        this.updateExperiment(featureKey);
      if (growthbook.isOn(featureKey) && templateValue) {
        this.redirect(templateValue, "template");
      }
    }

    ///// Utils

    redirect(value, type = null) {
      var url = new URL(window.location.toString());
      // if redirect test ...
      if (type == "template") {
        if (template.suffix === value.suffix) {
          this.log("Cannot redirect to variant...");
          return false;
        }
        url.searchParams.set("view", value.suffix);
      }
      this.queueRedirect(url);
      return true;
    }

    testForTemplate(templateKey) {
      const type = this.typeFromTemplate();
      const url = new URL(window.location.href);
      const value = growthbook.getFeatureValue(
        templateKey,
        null
      );

      if (!_isEmpty(value)) {
        this.log(`growthbook ${templateKey} value`, value);
        const result = growthbook.evalFeature(templateKey);
        this.log(`growthbook ${templateKey} evalFeature`, result);
      }

      if (
        !_isEmpty(value) &&
        !_isEmpty(value.type) &&
        !_isEmpty(value.suffix) &&
        type != null &&
        type === value.type &&
        template.suffix !== value.suffix &&
        !url.searchParams.has("view")
      ) {
        return value;
      }
      return null;
    }

    typeFromTemplate() {
      switch (template.type) {
        case "product":
          return template.type;
        default:
          return null;
      }
    }

    queueRedirect(url) {
      // this.saveState();
      window.setTimeout(() => { window.location.assign(url) }, 0);
    }

    // Ensure the "view" parameter is cleaned up from the URL, such that
    // the user is not aware of it and doesn't stay permanent.
    handleURLFromTest() {
      const url = new URL(window.location.href);
      if (url.searchParams.has("view")) {
        setTimeout(() => {
          const url = new URL(window.location.href);
          url.searchParams.delete("view");
          window.history.replaceState({}, '', `${url.pathname}${url.search.toString()}`);
        }, 500);
      }
    }

    loadState() {
      const cookie = this.getCookie();
      return cookie?.state || {};
    }

    saveState() {
      const cookie = this.getCookie();
      cookie.state = _extend(cookie.state, this.state);
      Cookies.set("_jaanuu_essential", JSON.stringify(cookie), { months: 12 });
    }

    setDebug(debug) {
      this.state.debug = debug;
      this.saveState();
    }

    setDebugTrace(debug) {
      this.state.debugTrace = debug;
      this.saveState();
    }

    log() {
      this.state.debug && console.debug('[edge] ', ...arguments);
      this.state.debugTrace && console.trace();
    }
  }

  // Run when GrowthBook SDK is loaded
  window.growthbook_queue.push((gb) => {
    growthbook = gb;
    window.jaEdge || (
    window.jaEdge = new Edge(
      dataset?.debug === "true",
      dataset?.debugTrace === "true"
    ));
    window.jaEdge.init();

    // Called initially and plus whenever new data is received
    document.addEventListener("growthbookdata", () => {
      window.jaEdge.run();
    });
  });
  // (function() {
  //   window.jaEdge = new Edge(
  //     Shopify.debug
  //   );
  //   window.jaEdge.init();
  // })();
})(window, document);
